import heroImg from '../components/images/ranchWeddingImages/image19.jpeg';
import cardImg1 from '../components/images/ranchWeddingImages/lakeside.jpg';
import cardImg2 from '../components/images/ranchWeddingImages/image9.jpeg';
import cardImg3 from '../components/images/ranchWeddingImages/image12.jpeg';
import '../assets/css/home.css';

export default function Home() {
  return (
    <>
      <div className="home-hero">
        <img className="home-hero-img" src={heroImg} alt="Cascade Mountain Ranch" />
        <div className="home-hero-overlay">
          <p className="home-hero-eyebrow">Hugo, Oregon</p>
          <h1>Cascade Mountain Ranch</h1>
          <div className="home-hero-divider"></div>
          <p className="home-hero-sub">Oregon's Premier Wedding & Event Destination</p>
          <a className="home-hero-cta" href="/packages">Explore Packages</a>
        </div>
      </div>

      <div className="home-intro">
        <div className="home-intro-inner">
          <div className="home-accent-line"></div>
          <h2>Where Every Moment Becomes a Memory</h2>
          <p>
            Just outside Grants Pass, Oregon you will find the little hamlet of Hugo, where Cascade
            Mountain Ranch sits nestled into the foothills between Mt. Sexton and Mt. Roberts. You
            and your guests can enjoy spectacular mountain views from the comfort of our two mountain
            lodges. Our seasonal creeks wind their way to two lakes — one featuring our 6,000 sq ft
            event deck, the other home to our island gazebo. Whether you are getting married,
            planning a reunion, or hosting a retreat, Cascade Mountain Ranch provides the perfect
            setting to make your event unforgettable.
          </p>
          <a className="home-intro-btn" href="/contact">Get in Touch</a>
        </div>
      </div>

      <div className="home-cards">
        <a className="home-card" href="/venue">
          <img src={cardImg1} alt="Lakeside view at Cascade Mountain Ranch" loading="lazy" />
          <div className="home-card-overlay">
            <p className="home-card-label">The Ranch</p>
            <div className="home-card-divider"></div>
          </div>
        </a>
        <a className="home-card" href="/packages">
          <img src={cardImg2} alt="Wedding ceremony at Cascade Mountain Ranch" loading="lazy" />
          <div className="home-card-overlay">
            <p className="home-card-label">Weddings</p>
            <div className="home-card-divider"></div>
          </div>
        </a>
        <a className="home-card" href="/gallery">
          <img src={cardImg3} alt="Events and reunions at Cascade Mountain Ranch" loading="lazy" />
          <div className="home-card-overlay">
            <p className="home-card-label">Events & Reunions</p>
            <div className="home-card-divider"></div>
          </div>
        </a>
      </div>
    </>
  );
}
